<template>
<div>
	<form @submit.prevent="validateBeforeSubmit">
		<div class="form-group row">
			<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Descrição:</label>
			<div class="col-sm-10">
				<input type="text"
						name="descricao"
						v-validate="'required'"
						:class="{'is-invalid' : errors.has('descricao')}"
						v-model="form.descricao"
						class="form-control form-control-sm">
				<span  class="invalid-feedback" v-show="errors.has('descricao')">{{ errors.first('descricao') }}</span>
			</div>
		</div>
		<div class="form-group row">
			<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">Tipo:</label>
			<div class="col-sm-10">
				<select v-model="form.idTipoServico"
						name="idTipoServico"
						v-validate="'required'"
						:class="{'is-invalid' : errors.has('idTipoServico')}"
						class="form-control form-control-sm">
					<option value="0">Escolha</option>
					<option v-for="item in tiposServicos" :key="item.id" :value="item.id">{{item.descricao}}</option>
				</select>
				<span  class="invalid-feedback" v-show="errors.has('idTipoServico')">{{ errors.first('idTipoServico') }}</span>
			</div>
		</div>

		<!-- FLIGHAWARE -->
		<div v-if="form.idTipoServico == 4">
			<div class="form-group row">
				<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">Prefixos:</label>
				<div class="col-sm-4 input-group">
					<input type="text"
							v-model="prefixo"
							class="form-control form-control-sm">

					<div class="input-group-append">
						<button class="btn btn-sm btn-primary"
								type="button"
								@click="() => {

									if(prefixo.trim() != ''){
										form.prefixo.push({prefixo: prefixo, 
											idServico: 9, 
											origem: null, 
											destino: null, 
											emVoo: false,
											idFlight: null});
										prefixo = ''
									}
								}">
							ADD <fa-icon icon="arrow-right" transform="right-3" />
						</button>
					</div>

				</div>

				<div class="col-sm-6">
					<button class="btn btn-sm btn-outline-primary"
							type="button"
							@click="() => {
								if(!item.processando) {
									form.prefixo.splice(index, 1)
								}
								$forceUpdate()
							}"
							style="margin-right:5px"
							v-for="(item, index) in form.prefixo" :key="index">
						{{item.prefixo}} <fa-icon v-if="!item.processando" icon="times"></fa-icon>
					</button>
				</div>
			</div>

			<div class="row">
				<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">Servidores:</label>
				<div class="col-sm-10">
					<div class="form-group input-group" v-for="(item, index) in servidoresAdds" :key="index">
						<select class="form-control form-control-sm" v-model="item.obj">
							<option :value="null">ESCOLHA</option>
							<option v-for="(servidor, indexServidor) in servidores" :key="indexServidor" :value="servidor">
								{{servidor.tipo}} - {{servidor.descricao}}
							</option>
						</select>

						<div class="input-group-append">

							<button @click="servidoresAdds.splice(index, 1)" type="button" class="btn btn-sm btn-outline-danger">
								<fa-icon :icon="['far', 'trash-alt']" /> Excluir
							</button>

						</div>
					</div>

					<button class="btn btn-sm btn-primary form-group"
							type="button"
							@click="() => { servidoresAdds.push({obj: null}) }">
						ADD <fa-icon icon="plus" transform="right-3" />
					</button>
				</div>
			</div>
		</div>


		<div class="form-group row">
			<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Login:</label>
			<div class="col-sm-8">
				<input type="text"
						name="login"
						v-validate="'required'"
						:class="{'is-invalid' : errors.has('login')}"
						v-model="form.login"
						class="form-control form-control-sm">
				<span  class="invalid-feedback" v-show="errors.has('login')">{{ errors.first('login') }}</span>
			</div>
		</div>
		<div class="form-group row">
			<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Senha:</label>
			<div class="col-sm-8">
				<input type="text"
						name="senha"
						v-validate="'required'"
						:class="{'is-invalid' : errors.has('senha')}"
						v-model="form.senha"
						class="form-control form-control-sm">
				<span  class="invalid-feedback" v-show="errors.has('senha')">{{ errors.first('senha') }}</span>
			</div>
		</div>
		<div class="form-group row">
			<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Url:</label>
			<div class="col-sm-10">
				<input type="text"
						name="url"
						v-validate="'required|url'"
						:class="{'is-invalid' : errors.has('url')}"
						v-model="form.url"
						class="form-control form-control-sm">
				<span  class="invalid-feedback" v-show="errors.has('url')">{{ errors.first('url') }}</span>
			</div>
		</div>
		<div class="form-group row">
				<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Organização:</label>
			<div class="col-sm-6">
				<input type="text"
						name="organizacao"
						v-validate="'required'"
						:class="{'is-invalid' : errors.has('organizacao')}"
						v-model="form.organizacao"
						class="form-control form-control-sm">
				<span  class="invalid-feedback" v-show="errors.has('organizacao')">{{ errors.first('organizacao') }}</span>
			</div>
		</div>

		<hr />

		<div class="row">
			<div class="col-sm-12 text-right">
				<small class="float-left text-info"><fa-icon icon="info-circle" transform="left-3" />Campos com * são obrigatórios.</small>
				<button class="btn btn-success btn-sm">
					<fa-icon icon="check" transform="left-3" /> SALVAR
				</button>
			</div>
		</div>
	</form>
</div>
</template>

<script>
import axios from '../../routers/axios'
export default {

	props: {
		servidores: {
			type: Array,
			require: true
		},

		tiposServicos: {
			type: Array,
			require: true
		},

	},

    data(){
        return {
			prefixo: '',

			servidoresAdds: [],
            form: {
                id: 0,
                idTipoServico: 0,
                descricao: "",
                login: "",
                senha: "",
                url: "",
                organizacao: "",

            }
        }
	},

	mounted() {
		// console.log(this.servidores);
	},

    methods: {

        editar (item) {

			item = _.cloneDeep(item)

            this.form.id = item.id
            this.form.idTipoServico =  item.idTipoServico
            this.form.descricao = item.descricao
            this.form.login = item.login
            this.form.senha = item.senha
            this.form.url = item.url
			this.form.organizacao = item.organizacao

			this.form.prefixo = item.prefixo

			if(item.servidorEnvio != null){
				this.servidoresAdds = item.servidorEnvio.split('|').map(item => {
					return {
						obj: _.find(this.servidores, s => { return s.id == item})
					}
				})
			}
        },

        validateBeforeSubmit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.salva();
                }
            });
        },

        salva(){

            var data = {
                id: this.form.id,
                idTipoServico: this.form.idTipoServico,
                descricao: this.form.descricao,
                login: this.form.login,
                senha: this.form.senha,
                url: this.form.url,
				organizacao: this.form.organizacao,
				prefixo:  this.form.prefixo,
				servidorEnvio: _.join(this.servidoresAdds.map(i => { return i.obj.id}), '|')
			}

            this.$notify.loadIn('Salvando')

            if(this.form.id != 0){

                axios.put(this._getUrl('api/servico') + '/' + this.form.id, data).then(response => {
                    this.$emit('item-salvo', response.data)
                })

            } else {

                axios.post(this._getUrl('api/servico'), data).then(response => {
                    this.form.id = response.data.id
                    this.$emit('item-salvo', response.data)
                })
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/views/servico/cadastro.vue